// src/utils/roleAccess.js

export const ACCESS_LEVELS = {
  FULL: "F",
  VIEW: "V",
  NONE: "N",
};

/**
 * Backend service → frontend page mapping
 */
const SERVICE_TO_PAGE = {
  "User Management": "users",
  "Product Management": "products",
  "Customer Price Management": "discounts",
  "Margin Calculator Management": "marginCalculator",
  "Customer Orders Management": "orders",
  "Customer Quotes Management": "quotingTool",
};

/**
 * Convert backend operations → access level
 */
const opsToAccessLevel = (ops = []) => {
  if (!Array.isArray(ops) || ops.length === 0) {
    return ACCESS_LEVELS.NONE;
  }

  // Any write permission → FULL
  if (
    ops.includes("CREATE") ||
    ops.includes("UPDATE") ||
    ops.includes("DELETE") ||
    ops.includes("APPROVE")
  ) {
    return ACCESS_LEVELS.FULL;
  }

  // Read-only
  if (ops.includes("READ")) {
    return ACCESS_LEVELS.VIEW;
  }

  return ACCESS_LEVELS.NONE;
};

/**
 * Build access map from backend services
 * Example output:
 * {
 *   users: "F",
 *   products: "V",
 *   orders: "F"
 * }
 */
export const buildAccessMapFromServices = (services = []) => {
  const accessMap = {};

  services.forEach(({ service, operations }) => {
    const pageKey = SERVICE_TO_PAGE[service];
    if (!pageKey) return;

    accessMap[pageKey] = opsToAccessLevel(operations);
  });

  return accessMap;
};

/**
 * Check access
 */
export const hasAccess = (accessMap, page, required = "V") => {
  if (!accessMap || !accessMap[page]) return false;

  const rank = { N: 0, V: 1, F: 2 };
  return rank[accessMap[page]] >= rank[required];
};

export const canEdit = (accessMap, page) => {
  return accessMap?.[page] === ACCESS_LEVELS.FULL;
};

export const canApprove = (services, serviceName) => {
  if (!Array.isArray(services)) return false;

  const svc = services.find(s => s.service === serviceName);
  return Boolean(svc?.operations?.includes("APPROVE"));
};
